import { render, staticRenderFns } from "./listBaseTable.vue?vue&type=template&id=04965230&scoped=true&"
import script from "./listBaseTable.vue?vue&type=script&lang=js&"
export * from "./listBaseTable.vue?vue&type=script&lang=js&"
import style0 from "./listBaseTable.vue?vue&type=style&index=0&id=04965230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04965230",
  null
  
)

export default component.exports